/* eslint-disable react-hooks/exhaustive-deps */
import styled from 'styled-components';
import {
  SAColumns,
  SAHeaderProps,
  SAIcon,
  SAIcons,
  SAIconSize,
  SAPopover
} from '@saux/design-system-react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CUSTOMER, LOGOUT, MY_INFORMATION, USER_PROFILE } from '../../utils/constants';
import { simpleGTMDataLayer } from '../../utils/utilities';
import logo from '../../icons/QTLogo.png';
import logo_mobile from '../../icons/QTLogo_mobile.png';
import { useNavigate } from 'react-router-dom';


const QTHeader = styled.header<SAHeaderProps>`
  ${(props) => {
    const { theme } = props;
    return `
      align-items: center;
      background-color: ${theme?.color.primary.background};
      box-shadow: ${theme?.shadow.elevation.level2};
      display: flex;
      flex-direction: row;
      justify-content: space-between;
	  height: 80px;
	  padding: 0 15px;

      .header-logo,
      .header-logo-bug {
        line-height: 0;
      }

      .header-logo {
        display: block;
      }

      .header-logo-bug {
        display: none;
      }
	  
	  .main-header {
      align-items: center;
      width: auto;
      height: 100%;
      display: flex;
    }
    
    .header-text,
    .main-header div[data-testid="ColumnWrapper"] {
      height: 100%;
      align-items: center;
      width: 100%;
      flex: 1;
      justify-content: space-between;
      flex-wrap: nowrap;
    }
    
    .main-header div[data-testid="ColumnItem"]:nth-child(1) {
      flex-grow: 1;
      margin: 0 20px;
    }
    
    .main-header div[data-testid="ColumnItem"]:nth-child(2) {
      box-sizing: border-box;
      width: fit-content;
    }
    
    #profile-icon {
      cursor: pointer;
      float: right;
    }
    
    .header-text {
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      align-content: center;
      height: 100%;
    }
    .customer-name {
      text-align: center;
      text-transform: capitalize;
      font-size: 16px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: auto;
      height: fit-content;
      padding-bottom: 5px;
      line-height: normal;
      color: white;
      font-weight: bold;
      font-family: 'Lato';
      letter-spacing: .5px;
    }
    .customer-number {
      color: white;
      font-weight: 500;
      line-height: normal;
      font-size: 16px;
      font-family: 'Lato';
    }
    .main-header svg {
      margin-left: auto;
    }
    
    section {
      flex-grow: 1;
    }
	  
	  @media only screen and (max-width: 768px) {

      .header-logo {
        display: none;
      }

      .header-logo-bug {
        display: block;
        height: 80px;
        margin-top: 35px;
      }
	 }

  @media only screen and (max-width: 600px) {
        height: 70px;
        padding: 0 ${theme?.size.spacer.medium};

        .header-logo {
          display: none;
        }

        .header-logo-bug {
          display: block;
        }
    } 
	  
    `;
  }};
`;




function Header({ setDisplayModal, displayModal, signOut }: any) {

  const [referenceElement, setReferenceElement] = useState<Element | null>(null);
  const user = useSelector((state: any) => state.user);
  const [displayCustomer, setDisplayCustomerInHeader] = useState(true);
  const selectedConversation = useSelector((state: any) => state.chat.selectedConversation)
  let customer = selectedConversation?.participants && selectedConversation?.participants.find((con: any) => con.participantType === CUSTOMER);
  const history = useNavigate();

  useEffect(() => {
    const pageTodisplayHeader = ["message", "conversation-viewer", "archived-conversations"];
    let display = pageTodisplayHeader.find(p => window.location.pathname.includes(p)) ? true : false;
    setDisplayCustomerInHeader(display);
  })

  function handleProfileIcon(event: React.MouseEvent<HTMLElement>) {
    setReferenceElement(event.currentTarget);
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Profile-Icon-Click`,
      event_action: 'Button Click',
      event_category: window.location.pathname,
      event_label: `Profile Icon Click`,
      event_value: `${user.fullName} clicked profile icon.`
    });
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `Profile-Icon-Click-Snowplow`,
      event_action: 'Button Click',
      event_category: window.location.pathname + "/Snowplow",
      event_label: `Profile Icon Click`,
      event_value: `${user.fullName} clicked profile icon.`
    });
  }

  function handleClose(event: React.MouseEvent<HTMLElement> | MouseEvent, index: number | null) {
    setReferenceElement(null);
    if (index === 0) {
      setDisplayModal(!displayModal);
    } else if (index === 1) {
      signOut();
    }
    let label = index === 0 ? "UserProfile" : "LogOut";
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `${label}-Click`,
      event_action: 'Button Click',
      event_category: window.location.pathname,
      event_label: `User can click to perform ${label} action.`,
      event_value: `${user.fullName} clicked ${label} button.`
    });
    simpleGTMDataLayer({
      csrId: user.userName,
      event: `${label}-Click-Snowplow`,
      event_action: 'Button Click',
      event_category: window.location.pathname + "/Snowplow",
      event_label: `User can click to perform ${label} action.`,
      event_value: `${user.fullName} clicked ${label} button.`
    });
  }

  const getLogo = () => {
    return (
      <>
        <div className="header-logo">
          <img src={logo} alt="logo" width={225} height={44}></img>
        </div>
        <div className="header-logo-bug">
          <img src={logo_mobile} alt="logo_mobile" width={61} height={43}></img>
        </div>
      </>
    );
  }

  const getSection = () => {
    return (<>
      <div className="main-header" >
        <SAColumns columns={{ sm: [10, 2], xs: [10, 2] }}>
          <div className="header-text">
            <div className="customer-name">
              {displayCustomer ? customer?.name : ""}
            </div>
            <div className="customer-number">
              {displayCustomer ? customer?.phoneNumber : ""}
            </div>
          </div>
          <div
            id="profile-icon"
            data-testid="profile-icon"
            onClick={handleProfileIcon}
          >
            <SAIcon icon={SAIcons.menuProfile} size={SAIconSize.large} />
          </div>
        </SAColumns>
      </div>
      <SAPopover
        data={[USER_PROFILE, LOGOUT]}
        onClose={(e: MouseEvent, index: number | null) => handleClose(e, index)}
        placement="bottom-start"
        referenceElement={referenceElement}
        variant="popover-menu"
      />
    </>)
  }

  return (
    <QTHeader >
      {getLogo()}
      <section>{getSection()}</section>
    </QTHeader>
  );
}

export default Header